import React from 'react';
import { Navigate } from 'react-router-dom';
import Footer from '../../pages/LandingPage/Footer';
import Navbar from '../../pages/LandingPage/Navbar';

const CommonHeader = ({ children }) => {
    if (localStorage.getItem('token')) {
        return <Navigate to="/dashboard" replace />;
    }

    return <>
        <Navbar 
          fromLanding={false}
        />
        {children}
        <Footer />
    </>;
};

export default CommonHeader;